import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from './authService';


const user = JSON.parse(sessionStorage.getItem("nln-virtual-library-user-token"));

const initialState = {
    user: user ? user : null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

// Register the user
export const register = createAsyncThunk('auth/register', async (user, thunkAPI) =>{

    try {
        return await authService.register(user);
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
});

// edit user
export const editUser = createAsyncThunk('auth/edit', async (user, thunkAPI) =>{

    try {
        return await authService.editUser(user);
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
});

// Login the user
export const login = createAsyncThunk('auth/login', async (user, thunkAPI) =>{

    try {
        
        return await authService.login(user);
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
});

//Get users

export const getUsers = createAsyncThunk('users/getAll', async (_, thunkAPI) => {
    
    try {
        const token = thunkAPI.getState().auth.user.token;
        return await authService.getUsers(token);
    } catch (error) {
        const message  = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() 
        return thunkAPI.rejectWithValue(message);
    }
})



export const logout = createAsyncThunk( 'auth/logout', async () => {
    await authService.logout();
    // sessionStorage.removeItem("nln-virtual-library-user-token");
    // return true;
})



export const authSlice = createSlice({

    name: 'auth',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(register.pending, (state, action) => {
            state.isLoading = true;
           
        })
        .addCase(register.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.user = action.payload;
            
        })
        .addCase(register.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
            state.user = null;
        })
        .addCase(login.pending, (state, action) => {
            state.isLoading = true;
           
        })
        .addCase(login.fulfilled, (state, action) => {
            
            state.isLoading = false;
            state.isSuccess = true;
            state.user = action.payload;
            
            // console.log(action.payload.data.token);
            
        })
        .addCase(login.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
            state.user = null;
        })
        .addCase(logout.fulfilled, (state) => {
            state.user = null;
        })

        .addCase(getUsers.pending, (state) => {
            state.isLoading = true;
         })
        .addCase(getUsers.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.user = action?.payload?.data.results
            // state.resources = action.payload    
        })
    
        .addCase(getUsers.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
        })
    },
})

export const { reset } = authSlice.actions
export default authSlice.reducer;